/*
* @Author: tengmaoqing
* @Date:   2018-04-16 20:03:46
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-05-10 10:34:58
*/

const defaultTKD = {
  title: '回收宝-最专业的二手数码回收平台|手机回收,平板电脑回收,笔记本回收,数码产品回收',
  keywords: '手机回收,笔记本回收,平板电脑回收,二手手机回收,旧手机回收,电脑回收,专业高价回收',
  description: '回收宝-专业的电子产品回收平台，为你提供手机回收、平板电脑回收、笔记本回收等二手数码产品回收业务。快速估计、专业检测、到账及时，专业的团队提供高价回收服务，并有数据粉碎，隐私安全有保障。'
};

// TKD.js
function getTKD (meta, store) {
  const TKD = Object.assign({}, defaultTKD, meta);

  TKD.title = typeof TKD.title === 'function'
    ? TKD.title(meta, store)
    : TKD.title;

  TKD.keywords = typeof TKD.keywords === 'function'
    ? TKD.keywords(meta, store)
    : TKD.keywords;

  TKD.description = typeof TKD.description === 'function'
    ? TKD.description(meta, store)
    : TKD.description;

  return TKD;
};

const serverTKDMixin = (app, route, store, translate) => {
  if (!app.$ssrContext || !route) {
    return;
  }
  const TKD = getTKD(route.meta, store);
  const title = translate ? translate(TKD.title) : TKD.title;
  const keywords = translate ? translate(TKD.keywords) : TKD.keywords;
  const description = translate ? translate(TKD.description) : TKD.description;
  if (title) {
    app.$ssrContext.title = title;
  }

  if (keywords) {
    app.$ssrContext.keywords = keywords;
  }

  if (description) {
    app.$ssrContext.description = description;
  }
};

const clientTKDMixin = (app, route, store, translate) => {
  const TKD = getTKD(route.meta, store);
  if (TKD.title) {
    document.title = translate ? translate(TKD.title) : TKD.title;
    const ifr = document.createElement('iframe');
    ifr.style.display = 'none';
    ifr.src = 'https://mobile.huishoubao.com/mobile/m/oppo_service.html';
    ifr.onload = () => {
      setTimeout(() => {
        ifr.onload = null;
        document.body.removeChild(ifr);
      }, 0);
    };
    document.body.appendChild(ifr);
  }
};

export default process.env.VUE_ENV === 'server'
  ? serverTKDMixin
  : clientTKDMixin;



// WEBPACK FOOTER //
// ./src/helper/TKD.js